export default __webpack_public_path__ + "static/media/step.cb1e3acb.wav";